import {
  changeTransactionSignatureName,
  deleteTransactionSignature,
  moveModelOrScellementTransactionSignature,
  MoveSignature,
} from "@/state/transactions/CurrentTransactionEvents";
import { TransactionType } from "@/type/core/transaction/transaction.types";
import { CONSEIL_EXPERT_COMPTABLES } from "@/utils/Constant";
import useSignatoryCard from "@/utils/hooks/useSignatoryCard";
import SignatoryCardSignedByText from "@components/core/subComponents/SignatoryCard/SignatoryCardSignedByText";
import DeleteIcon from "@static/core/icons/icon-delete.svg?react";
import imageECMA from "@static/core/img/logo_ecma.png";
import imageUNIVERSIGN from "@static/core/img/utc_signature.png";
import { Signature } from "@type/core/dashboard/dashboard.types";
import { Input } from "antd";
import { Dispatch, FunctionComponent, SetStateAction } from "react";
import { useTranslation } from "react-i18next";
import SignatoryCardShadow from "@components/core/subComponents/SignatoryCard/SignatoryCardShadow";

interface ModelSignatoryCardProps {
  documentRank: number;
  transactionType: TransactionType;
  signature: Signature;
  signatures: Signature[];
  setManualPositioning: Dispatch<SetStateAction<boolean>>;
  className?: string;
  pageNumber: number;
  firstname: string;
  lastname: string;
  signatureIdentificator: string;
  cardDimensionHeight: number;
  cardDimensionWidth: number;
}

const ModelSignatoryCard: FunctionComponent<ModelSignatoryCardProps> = ({
  documentRank,
  transactionType,
  signature,
  signatures = [],
  setManualPositioning,
  className = "",
  pageNumber,
  firstname,
  lastname,
  signatureIdentificator,
  cardDimensionWidth,
}) => {
  const { t } = useTranslation();

  const onSetSignature = (movedSignature: MoveSignature) => {
    moveModelOrScellementTransactionSignature(movedSignature);
  };

  const { DraggableCard, signatureImageLeftInitialPosition } = useSignatoryCard(
    {
      rank: documentRank,
      transactionType,
      signature,
      signatures,
      setManualPositioning,
      className,
      pageNumber,
      onSetSignature,
      signatureIdentificator,
      isDisabled: false,
    },
  );

  const handleDeleteSignature = () => {
    deleteTransactionSignature({ identificator: signature.identificator });
  };

  const signatureToDisplay =
    transactionType === "scellement" ? imageECMA : imageUNIVERSIGN;
  const signatureName: string =
    (transactionType === "scellement"
      ? CONSEIL_EXPERT_COMPTABLES
      : signature.name) ?? "";

  return (
    <div className="d-flex position-relative mt-8">
      {transactionType === "signature" &&
      documentRank === 1 &&
      !signature.email ? (
        <div className="d-flex w-200px mb-8">
          <Input
            className="d-flex align-items-center font-extra-small w-75"
            value={signatureName}
            onChange={(event) =>
              changeTransactionSignatureName({
                id: signature.id,
                name: event.target.value,
                order: signature.order,
              })
            }
          />
        </div>
      ) : (
        <div
          className={`d-flex align-items-center font-extra-small mb-8 ${transactionType === "scellement" ? "w-300px" : "w-200px"}`}
        >
          {signatureName}
        </div>
      )}
      <SignatoryCardShadow
        documentRank={documentRank}
        transactionType={transactionType}
        name={signatureName}
        email={transactionType === "signature" ? "" : "scellement"}
        firstname={firstname}
        lastname={lastname}
        signatures={signatures}
        left={`${signatureImageLeftInitialPosition}px`}
        signatureIdentificator={signatureIdentificator}
      />
      <DraggableCard>
        <SignatoryCardSignedByText
          firstname={firstname}
          lastname={lastname}
          cardDimensionWidth={cardDimensionWidth}
          transactionType={transactionType}
        />
        <img src={signatureToDisplay} className={"signatory-image"} />
      </DraggableCard>
      {signature && !signature.email && (
        <div
          className="d-flex align-items-center mb-8 ml-16"
          onClick={handleDeleteSignature}
          title={t("signature.positioning.deleteSignature")}
        >
          <DeleteIcon className="picto text-tertiary icon-30" />
        </div>
      )}
    </div>
  );
};

export default ModelSignatoryCard;
